export default __webpack_public_path__ + "static/media/average-icon.c6022a60.svg";